import { render, staticRenderFns } from "./TribunalOrders.vue?vue&type=template&id=5e270716"
import script from "./TribunalOrders.vue?vue&type=script&lang=js"
export * from "./TribunalOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports